import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Organization } from "../../../@types/organization";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const findOrganizations = createAsyncThunk(
  "organizations/find",
  async (searchText, { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    try {
      const { data } = await axiosInstance.get(`${api.baseURL}organization`, {
        params: {
          where: { 
            domain: { "!=": "guardservice" },
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          },
          sort: "name ASC",
          limit: 10000,
        },
      });
      return data as Organization[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
